<div class="mon-dialog-header">
    <h3 class="pt-6 mt-3 inline-block">
    <span class="inline-block" *ngIf="!downloadDone" translate>
            Select your export file
        </span>
    <span class="inline-block" *ngIf="downloadDone" translate>
            Your export is currently being generated.
        </span>
    </h3>
</div>
<div class="mon-dialog-body auto-scroll">
    <div class="row pb-3" *ngIf="downloadDone">
        <div class="col-48 pt-3 px-6">
            <p translate class="text-bold">
                You will receive an email when the export is ready.
            </p>
            <p translate>
                To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class="text-bold">My Exports.</span>
            </p>
            <p translate>Alternatively, click the button below.</p>
            <button (click)="goToExports()" mon-event-trigger="actionTrigger" mon-event-params="{action: 'open-my-exports-btn'}" class="mt-3 btn-block btn btn-border-radius btn-secondary py-6">
                <span class="fas fa-fw fa-lg fa-file-download mr-2" aria-hidden="true"></span>
                <span translate class="inline-block font-size-1-1">
                    Go to My Exports
                </span>
            </button>
        </div>
    </div>
    <div class="row pb-3" *ngIf="!downloadDone">
        <div class="col-48 pt-3 px-6 text-center" *ngIf="onDownload">
            <span class="fas mt-4 fa-spinner fa-spin fa-2x" aria-hidden="true"></span>
        </div>
        <ng-container *ngIf="!onDownload">
            <ng-container *ngFor="let export of exports; let i = index">
                <div class="col-48 pt-3 px-6"
                    [ngbTooltip]="export.tooltip | translate"
                     [placement]="'bottom'"
                     [triggers]="'focus mouseenter'"
                     [container]="'body'">
                    <mon-date-picker
                        [(date)]="date"
                        [monDateFormat]="dateFormat"
                        [options]="datepickerOptions"
                    >
                    </mon-date-picker>
                    <button type="button"
                      class="btn-block btn btn-border-radius btn-secondary py-6 mt-2"
                      (click)="download(export.data)">
                  <span class="fas fa-2x fa-download mr-2 inline-block" aria-hidden="true">
                  </span>
                  <span class="inline-block font-size-1-1">
            {{ export.name || ('Start export' | translate) }}
                  </span>
              </button>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
    